import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AceTextModule} from '../../../sc-ace-text/src/app/ace-text/ace-text.module';
import {DocumentEditorModule} from '../../../sc-document-editor/src/app/document-editor/document-editor.module';
import {DocumentDownloaderModule} from '../../../sc-document-downloader/src/app/document-downloader/document-downloader.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AceTextModule,
    DocumentEditorModule,
    DocumentDownloaderModule
  ],
  providers: [],
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class AppModule {
  constructor() { }

  // ngDoBootstrap needs to do nothing when exporting custom elements so that the normal Angular app bootstrap doesn't take place
  ngDoBootstrap() {}
}
